module.exports = __webpack_public_path__ + "9165f576dcc6f69c3876db3690cd3f06.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/bg.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/bg.jpg
// module chunks = 40